// extracted by mini-css-extract-plugin
module.exports = {"tab-container":"tabs_tab-container__AFKqV","tab":"tabs_tab__fKFcR","selected":"tabs_selected__1gBO-","number":"tabs_number__3apYX"};